export const setupCffModalFilters = (componentProps, allDependencies) => {
    const cffModal = allDependencies.cffChangeModal;
    if (!cffModal?.fundId) {
        return componentProps;
    }
    const filters = {
        "Fund.FundId": [cffModal.fundId]
    };
    // In a filter context, the Fund.InvestorId requires the ID of the Investor Entity, not the Investment ID which is what the Fund.InvestorId datapoint returns
    if (cffModal.investorInvestorId) {
        filters["Fund.InvestorId"] = [cffModal.investorInvestorId];
    }
    return {
        ...componentProps,
        defaultFilters: {
            ...componentProps.defaultFilters,
            ...filters
        }
    };
};
